import { IUserBase, UserExperience, UserGender } from '../../models/users';
import wbsBookingsApi from '../apis/wbsBookingsApi';

interface ICreateUserProps {
  bio?: string;
  birthDate?: Date;
  categoryId?: string;
  cpf?: string;
  email: string;
  experience?: UserExperience;
  featureGroupId?: string;
  featureGroupKey?: string;
  gender?: UserGender;
  healthCheck?: Date;
  hostId?: string;
  name: string;
  phone?: string;
  ventureId?: string | null;
}

export type INewUser = IUserBase;

export const createUsersService = async ({
  bio,
  birthDate,
  categoryId,
  cpf,
  email,
  experience,
  featureGroupId,
  featureGroupKey,
  gender,
  healthCheck,
  hostId,
  name,
  phone,
  ventureId,
}: ICreateUserProps): Promise<INewUser> => {
  const { data } = await wbsBookingsApi.post<INewUser>('/users', {
    bio,
    birthDate,
    categoryId,
    cpf,
    email,
    experience,
    featureGroupId,
    featureGroupKey,
    gender,
    healthCheck,
    hostId,
    name,
    phone,
    ventureId,
  });

  return data;
};
